import React from "react";

import { fontFamily } from "./styles";

const Text = ({ children, style, mt, marginTop }) => (
  <p
    style={{
      fontSize: "18px",
      fontFamily,
      color: "#000000",
      marginTop: marginTop ? marginTop : mt ? "4em" : "0",
      marginBottom: "2em",
      ...style
    }}
  >
    {children}
  </p>
);

export default Text;



// WEBPACK FOOTER //
// ./src/components/analysis/Text.js